import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getMarketBar,
  GetMarketBarData,
  GetMarketBarParams,
} from '../../../api/v1/market'

export const getMarketBarAction = createAsyncThunk<
  GetMarketBarData,
  GetMarketBarParams
>('market/getMarketBar', async ({ symbol, type }) => {
  const r = await getMarketBar({ symbol, type })
  return r.data
})
